module.exports = __webpack_public_path__ + "img/designguide@2x.6180e36.jpg";